module.exports = __webpack_public_path__ + "static/wohnformen_mini-620df976b4c135285fba009da06d44eb.png";